import React, { useState } from 'react';
import PasswordRequirements from '../common/PasswordRequirements';
import AuthErrorMessage from '../messages/AuthErrorMessage';
import AuthFormLayout from '../layouts/AuthFormLayout';
import { FloatingLabelInput } from '../common/FloatingLabelInput';
import AuthNavButton from '../common/AuthNavButton';

interface ResetPasswordConfirmFormProps {
  onSubmit: (email: string, code: string, newPassword: string) => Promise<void>;
  onSwitchToSignIn: () => void;
  isLoading: boolean;
  error?: string | null;
  email: string;
}

const ResetPasswordConfirmForm: React.FC<ResetPasswordConfirmFormProps> = ({
  onSubmit,
  onSwitchToSignIn,
  isLoading,
  error,
  email,
}) => {
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) return;
    await onSubmit(email, code, newPassword);
  };

  return (
    <AuthFormLayout
      title="Reset Password"
      footer={
        <div className="mt-4 text-center">
          <AuthNavButton onClick={onSwitchToSignIn}>Back to sign in</AuthNavButton>
        </div>
      }
      onSubmit={handleSubmit}
    >
      <AuthErrorMessage error={error} />
      <div className="space-y-4">
        <FloatingLabelInput
          label="Confirmation Code"
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          required
        />
        <FloatingLabelInput
          label="New Password"
          type="password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          required
        />
        <FloatingLabelInput
          label="Confirm New Password"
          type="password"
          value={confirmNewPassword}
          onChange={e => setConfirmNewPassword(e.target.value)}
          required
        />
        <PasswordRequirements password={newPassword} />
        {confirmNewPassword && newPassword !== confirmNewPassword && (
          <div className="mt-1 text-xs text-red-500">Passwords do not match</div>
        )}
      </div>
      <div>
        <button
          type="submit"
          className="mt-4 w-full rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2 disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800"
          disabled={
            isLoading || newPassword !== confirmNewPassword || !newPassword || !confirmNewPassword
          }
        >
          {isLoading ? 'Resetting...' : 'Reset Password'}
        </button>
      </div>
    </AuthFormLayout>
  );
};

export default ResetPasswordConfirmForm;
